<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftActivityPanel from '../../../../../../shifts/components/panels/ShiftActivityPanel.vue'
import { Shift } from '../../../../../../shifts/models/shift'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,

  },
})

const { siteId, shift } = defineProps<{
  siteId: SiteID
  shift: Shift
}>()
</script>

<template>
  <ShiftActivityPanel :site-id="siteId" :shift="shift" />
</template>
